import FormGroup from '@mui/material/FormGroup'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Switch from '@mui/material/Switch'

import styles from './styles.module.scss'

interface SwitchProps {
  textLeft: string
  textRight: string
  isSkuChecked: boolean
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  border: '1px solid #646464',
  borderRadius: '50px',
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 1,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#6633cc',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#6633cc' : '#fff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#fff' : '#6633cc',
    boxSizing: 'border-box',
  },
}))

export default function CustomizedSwitches({
  textLeft,
  textRight,
  isSkuChecked,
  handleChange,
}: SwitchProps) {
  return (
    <FormGroup className={styles.switch}>
      <Stack direction="row" spacing={1} alignItems="center">
        <div className={styles.text}>{textLeft}</div>
        <AntSwitch
          checked={isSkuChecked}
          onChange={handleChange}
          inputProps={{ 'aria-label': 'ant design' }}
        />
        <div className={styles.text}>{textRight}</div>
      </Stack>
    </FormGroup>
  )
}
